import React from 'react';
import { Box, Checkbox, Text, Loader } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { useSetPaymentsEnabled } from '../../../stores/appStore';
import { getProviderConfig } from 'config/providers';
import { usePaymentConnectionState } from 'hooks/usePaymentConnectionState';

export function AcceptTerms() {
  const { t } = useTranslation();
  const setPaymentsEnabled = useSetPaymentsEnabled();
  const { isLoading, isPaymentProviderAvailable, paymentsEnabled } = usePaymentConnectionState();

  const { vendor, terms } = getProviderConfig();
  const termsI18nKey = `accept_terms.${vendor.toLowerCase()}`;

  if (isLoading) {
    return (
      <Box align="center" padding="16px">
        <Loader size="small" />
      </Box>
    );
  }

  const termsLinkComponents = Object.fromEntries(
    Object.entries(terms.linkKeys).map(([key, i18nKey]) => [
      key,
      <a href={t(i18nKey)} target="_blank" rel="noopener noreferrer">
        -
      </a>,
    ]),
  );

  return (
    <Box direction="vertical" gap="16px">
      <Box gap="12px" marginTop="12px" verticalAlign="top">
        <Text size="small">
          <Trans i18nKey={termsI18nKey} components={termsLinkComponents} />
        </Text>
      </Box>

      {isPaymentProviderAvailable && (
        <Checkbox checked={paymentsEnabled} onChange={(e) => setPaymentsEnabled(e.target.checked)}>
          <Text size="small">
            <Trans
              i18nKey="accept_terms.enable_payments"
              components={{
                paymentsLink: (
                  <a href={t('links.wix_payments_terms')} target="_blank" rel="noopener noreferrer">
                    -
                  </a>
                ),
                serviceFeesLink: (
                  <a href={t('links.wix_service_fees')} target="_blank" rel="noopener noreferrer">
                    -
                  </a>
                ),
              }}
            />
          </Text>
        </Checkbox>
      )}
    </Box>
  );
}
